export const convertData = (a, b) => {
  if (!b.tickets) return;
  return [
    ...a,
    ...b.tickets?.map((ticket, index) => ({
      ...ticket,
      key: ticket?.vgsTicketCode || ticket?.sapVerifyCode,
      productName: b?.show?.name,
      orderItemId: b?.id,
      catalog: b?.show?.catalog?.name,
    })),
  ];
};

export const sortByKey = (list, key) => {
  return list.sort(function (a, b) {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
};
